import type * as SocketCloudTypes from '@aaimplatform/socket-cloud-types/generated/socket-cloud.types';
// Import the Socket.IO based WebSocket service
import { wsService } from './websocket';

type NodeStatusSocketEvent = SocketCloudTypes.components['schemas']['NodeStatusSocketEvent'];
type SecuritySocketEvent = SocketCloudTypes.components['schemas']['SecuritySocketEvent'];

// Export the Socket.IO service
export { wsService };

// Export subscription helpers directly
export const subscriptions = {
  /**
   * Subscribe to node status changes
   */
  onNodeStatus(handler: (event: NodeStatusSocketEvent) => void): () => void {
    return wsService.subscribe('node:status', handler);
  },

  /**
   * Subscribe to real-time metrics
   */
  onMetrics(handler: (metrics: any) => void): () => void {
    return wsService.subscribe('node:metrics', handler);
  },

  /**
   * Subscribe to consensus state changes
   */
  onConsensusState(handler: (state: any) => void): () => void {
    return wsService.subscribe('consensus:state', handler);
  },

  /**
   * Subscribe to network topology changes
   */
  onNetworkTopology(handler: (topology: any) => void): () => void {
    return wsService.subscribe('network:topology', handler);
  },

  /**
   * Subscribe to new alerts
   */
  onNewAlert(handler: (alert: any) => void): () => void {
    return wsService.subscribe('alert:new', handler);
  },

  /**
   * Subscribe to security events
   */
  onSecurityEvent(handler: (event: SecuritySocketEvent) => void): () => void {
    return wsService.subscribe('security:event', handler);
  },

  /**
   * Subscribe to CRDT updates
   */
  onCRDTUpdate(handler: (update: any) => void): () => void {
    return wsService.subscribe('crdt:update', handler);
  },

  /**
   * Subscribe to connection status
   */
  onConnectionStatus(handler: (status: { connected: boolean; reason?: string }) => void): () => void {
    const connectHandler = () => handler({ connected: true });
    const disconnectHandler = (data: any) => handler({ connected: false, reason: data.reason });

    // The names websocket-socketio.ts routes the socket's own connect and
    // disconnect under.
    const unsubConnect = wsService.subscribe('connected', connectHandler);
    const unsubDisconnect = wsService.subscribe('disconnected', disconnectHandler);

    return () => {
      unsubConnect();
      unsubDisconnect();
    };
  },
};